module.exports = __webpack_public_path__ + "img/icon_mail.56993ecb.svg";